import request from "root/js/request";

export const getSharesList = async ({ cabinet_id }) => {
  const response = await request({
    url: `/analytics/shares/?cabinet_id=${cabinet_id}`,
    method: "get",
  });
  return response;
};
